import DocumentIntelligenceProvidersService from "@/services/DocumentIntelligenceProvidersService";
import Utils from "@/ecm/common/Utils";

export default class BlockedDocumentsService {

  constructor(context) {
    this.context = context;
  }

  async checkDocumentAvailability(messageId) {
    return await DocumentIntelligenceProvidersService.checkDocumentAvailability(messageId);
  }

  async confirmBlockAction(result, isDelete) {
    const lockedByUserMessage = this.context.$t("DocumentLockedByAnotherUser")
    .replaceAll("{0}", result.UserLogin)
    .replaceAll("{1}", Utils.date.toUserFormatFromIso(result.LockTimestamp));

    let warningMessage = "";
    if (isDelete) {
    warningMessage = this.context.$t("DocumentLockWarningToDelete").replaceAll("{0}", result.UserLogin);
    } else {
    warningMessage = this.context.$t("DocumentLockedWarning").replaceAll("{0}", result.UserLogin);
    }
    const fullMessage = `${lockedByUserMessage}<br><br>${warningMessage}`;

    return new Promise((resolve) => {
    this.context.$confirm(fullMessage, {
        title: this.context.$t("DocumentBlocked"), 
        icon: "mdi-warning",
        color: "orange",
        buttonTrueText: isDelete ? this.context.$t("Delete") : this.context.$t("TakeControl"),
        buttonFalseText: this.context.$t("Cancel"),
    }).then((res) => {
        resolve(res === 1); 
    });
    });
  }
}
